import PanelSection from "../intelligence/PanelSection";
import { formatCompletedTime, runStatusLabel } from "../intelligence/intelligenceLabels";
import SourceHealthBadge from "./SourceHealthBadge";

const RecentIngestionRunsCard = ({ runs }) => {
  const items = (runs || []).slice(0, 20);

  return (
    <PanelSection eyebrow="Ingestion" title="Recent runs" countLabel={`${items.length} shown`}>
      {!items.length ? (
        <p className="muted">No ingestion runs recorded yet.</p>
      ) : (
        <div className="admin-data-health-runs">
          {items.map((run) => (
            <article key={run.runId} className="admin-data-health-run-row">
              <div className="admin-data-health-run-row__head">
                <strong>{run.sourceName || run.sourceCode}</strong>
                <SourceHealthBadge status={run.runStatus} />
              </div>
              <p className="admin-data-health-meta">
                {formatCompletedTime(run.startedAt)} → {formatCompletedTime(run.completedAt)}
              </p>
              <p className="admin-data-health-meta">
                {runStatusLabel(run.runStatus)} · received {run.recordsReceived} · inserted{" "}
                {run.recordsInserted} · updated {run.recordsUpdated} · failed {run.recordsFailed}
              </p>
              {run.errorMessage ? (
                <p className="admin-data-health-error">{run.errorMessage}</p>
              ) : null}
            </article>
          ))}
        </div>
      )}
    </PanelSection>
  );
};

export default RecentIngestionRunsCard;
